export enum CallInviteStatusType {
  Ringing = 'ringing',
  Accepted = 'accepted',
  Declined = 'declined',
  Missed = 'missed',
  Cancelled = 'cancelled',
}
